module.exports = __webpack_public_path__ + "static/media/logo-full.45bbc142.png";